import { initContract } from '@ts-rest/core';
import { z } from 'zod';
const c = initContract();
export const healthContract = c.router({
    check: {
        method: 'GET',
        path: '/health',
        responses: {
            200: z.object({
                status: z.enum(['healthy', 'degraded']),
                timestamp: z.string(),
                dependencies: z
                    .object({
                    dynamodb: z.enum(['ok', 'error']).optional(),
                    ssm: z.enum(['ok', 'error']).optional(),
                })
                    .optional(),
            }),
        },
        summary: 'Health check endpoint',
    },
});
//# sourceMappingURL=health.js.map